import { defer, LoaderFunction } from 'react-router-dom'

import AccountAlert from '@models/AccountAlert'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type MessagesResponse = {
  alerts: AccountAlert[]
  remaining: boolean
}

export type MessagesLoaderResponse = {
  messages: Promise<MessagesResponse>
}

export const MESSAGES_PAGE_SIZE = 20

const messagesLoader: LoaderFunction = async () => {
  const messages = http.loader.post(ApiRoutes.members.messagesPath(), {
    limit: MESSAGES_PAGE_SIZE,
  })
  return defer({ messages })
}

export default messagesLoader
